module.exports = "<cat-navigation></cat-navigation>\n<router-outlet></router-outlet>\n<cat-loader></cat-loader>\n<cat-server-notifications></cat-server-notifications>\n<cat-notifications></cat-notifications>\n<p-confirmDialog header=\"Confirmation\" icon=\"fa fa-question-circle\" width=\"425\"></p-confirmDialog>\n"


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/base-app/components/app-component/app.component.html
// module id = ../../../../../src/app/modules/base-app/components/app-component/app.component.html
// module chunks = main